import React from 'react'

const About = () => {
  return (
    <section id="sobre">
      <div className="info-container">
        <div>
          <h2 style={{ color: 'var(--primary)', marginBottom: '20px' }}>
            Sobre Nós
          </h2>
          <div className="about-card">
            <p>
              <strong>Agrosinal Tecnologia</strong> é um laboratório de
              tecnologia agrícola, atuamos no mercado desde setembro 2020,
              focados em agricultura de precisão, unimos conhecimento técnico e
              agilidade para garantir que seu equipamento tenha a máxima
              performance. Assistencia técnica em eletrônica aplicada ao
              agronegócio, com atendimento no campo, em Naviraí e toda região.
              Oferecemos diagnóstico, manutenção, reparo e suporte técnico em
              monitores agrícolas, antenas GPS, sistemas de automação, sensores
              e equipamentos eletrônicos de precisão, garantindo funcionamento
              correto e confiável diretamente na sua propriedade.
              <br />
              <br />
              Nosso diferencial é o{' '}
              <strong>atendimento técnico no local</strong>, reduzindo o tempo
              de parada das máquinas e aumentando a eficiência das operações
              agrícolas. Trabalhamos com seriedade, conhecimento técnico e
              compromisso com resultados.
            </p>
            <br />
            <p>Equipe Agrosinal Tecnologia.</p>
          </div>
        </div>

        <div className="info-card">
          <h3>Onde Atendemos</h3>

          <p>
            <i className="fas fa-map-marker-alt"></i> Naviraí - MS (Presencial)
          </p>
          <h2
            style={{
              color: 'var(--primary)',
              marginBottom: '20px',
              fontSize: '1.2rem'
            }}
          >
            Av. Brasil 1202 Centro CEP:79950-000
          </h2>

          <p>
            <i className="fas fa-truck"></i> Demais localidades: Atendimento via
            agendamento pelo WhatsApp.
          </p>
          <div className="schedule-box">
            <strong>Horário de Atendimento:</strong>
            <br />
            Segunda a Sábado: 08:00 às 18:00
            <br />
            <strong>Plantão Emergencial 24h</strong>
          </div>
        </div>
      </div>
    </section>
  )
}

export default About
